import * as React from "react"

const SocialShare = ({
  twitterLink = "https://twitter.com/capsulecrm?lang=en",
  facebookLink = "https://www.facebook.com/capsulecrm/",
  linkedinLink = "https://www.linkedin.com/company/capsulecrm/",
  className = "",
}) => {
  return (
    <div className={`social-share ${className}`}>
      <a
        href={twitterLink}
        className="social-share__icon social-share__icon--twitter"
        title="Capsule Twitter Account"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          className="social-share__icon-svg"
          fill="none"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m17 3.65886c-.6002.28523-1.2352.47314-1.885.55781.6829-.43736 1.1964-1.13219 1.4443-1.95416-.6456.41292-1.3508.70264-2.0853.85676-.3093-.35454-.6813-.63659-1.0934-.829-.412-.19242-.8556-.29117-1.3036-.29026-1.814 0-3.282 1.58228-3.282 3.5328-.00129.27131.02714.54181.08467.80572-1.30077-.06669-2.57449-.42963-3.73968-1.06558-1.16518-.63595-2.19616-1.53091-3.02699-2.62763-.29148.53743-.44562 1.15063-.44633 1.77551 0 1.225.58433 2.30781 1.46666 2.94218-.52275-.01357-1.0348-.1649-1.49266-.44114v.04375c0 1.71353 1.13333 3.13908 2.63333 3.46348-.28207.0823-.57274.124-.86467.124-.20714.0004-.41381-.0216-.617-.0656.417 1.4036 1.63067 2.4245 3.06834 2.4536-1.16821.9847-2.60246 1.517-4.07734 1.513-.26179-.0004-.52334-.0174-.78333-.051 1.50039 1.0479 3.24448 1.6022 5.02467 1.5969 6.04533 0 9.34803-5.3849 9.34803-10.05521 0-.15313-.0037-.30625-.0104-.45573.6411-.49873 1.1956-1.1185 1.6377-1.8302z" />
        </svg>
      </a>
      <a
        href={facebookLink}
        className="social-share__icon social-share__icon--facebook"
        title="Capsule Facebook Page"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          className="social-share__icon-svg"
          fill="none"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 10.06C20 4.505 15.522 0 10 0S0 4.505 0 10.06c0 5.022 3.656 9.184 8.438 9.94v-7.03h-2.54v-2.91h2.54V7.844c0-2.521 1.493-3.915 3.777-3.915 1.094 0 2.239.197 2.239.197v2.476h-1.262c-1.242 0-1.63.775-1.63 1.572v1.886h2.773l-.443 2.91h-2.33V20C16.345 19.245 20 15.083 20 10.06z"
          />
        </svg>
      </a>
      <a
        href={linkedinLink}
        className="social-share__icon social-share__icon--linkedin"
        title="Capsule LinkedIn Page"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          className="social-share__icon-svg"
          fill="none"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18.4 0H1.71C.797 0 0 .656 0 1.558v16.728C0 19.192.797 20 1.709 20h16.686c.918 0 1.605-.813 1.605-1.714V1.558C20.005.656 19.312 0 18.4 0zM6.2 16.671H3.334V7.762H6.2v8.909zM4.866 6.408h-.02c-.917 0-1.511-.683-1.511-1.537 0-.87.61-1.537 1.547-1.537.937 0 1.51.662 1.531 1.537 0 .854-.594 1.537-1.547 1.537zm11.805 10.263h-2.865V11.8c0-1.167-.417-1.964-1.454-1.964-.792 0-1.26.535-1.469 1.057-.078.188-.1.443-.1.704v5.074H7.92V7.762h2.865v1.24c.417-.594 1.068-1.448 2.584-1.448 1.88 0 3.303 1.24 3.303 3.912v5.205z" />
        </svg>
      </a>
    </div>
  )
}

export default SocialShare
